export const WORK_MANAGEMENT_TABS = Object.freeze([
  { text: '업무 목록', value: 'works' },
  { text: '내 할일', value: 'my-items' },
  { text: '알림', value: 'notifications' },
  { text: '템플릿', value: 'templates' },
  { text: 'Runtime 설정', value: 'runtime-definitions' },
  { text: '외부 이벤트', value: 'external-events' },
])

export function workManagementTabsForEnvironment(environment) {
  if (environment !== 'production') return WORK_MANAGEMENT_TABS
  return WORK_MANAGEMENT_TABS.filter(tab => tab.value !== 'runtime-definitions')
}

const ROUTE_TAB_MAP = Object.freeze({
  WorkManagement: 'works',
  WorkDetail: 'works',
  WorkItemRedirect: 'works',
  MyWorkItems: 'my-items',
  WorkNotifications: 'notifications',
  WorkTemplateLayout: 'templates',
  WorkTemplateList: 'templates',
  WorkTemplateCreate: 'templates',
  WorkTemplateDetail: 'templates',
  WorkTemplatePublish: 'templates',
  RuntimeDefinitionList: 'runtime-definitions',
  RuntimeDefinitionCreate: 'runtime-definitions',
  RuntimeDefinitionDetail: 'runtime-definitions',
  WorkExternalEvents: 'external-events',
})

export function workManagementTabPath(projectId, value) {
  const base = `/work-management/${projectId}`
  if (value === 'works') return base
  return `${base}/${value}`
}

export function workManagementActiveTab(routeName) {
  return ROUTE_TAB_MAP[routeName] || 'works'
}

export function isWorkManagementRouteName(routeName) {
  return (
    routeName === 'WorkManagementLayout' ||
    Object.prototype.hasOwnProperty.call(ROUTE_TAB_MAP, routeName)
  )
}
